// @ts-nocheck
export const GET_PHONE_SIMPLE_DIALOG_TRANSLATION_KEY =
  'get-phone-simple-dialog';
